import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { documentationContent } from '../documentationContent';

const AUTH_DOC_PATH = '/Documentation/3-auth.md';

const markdownComponents = {
    img: ({ alt, src }) => (
        <img
            src={src}
            alt={alt || 'Authentication sequence diagram'}
            style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '1rem' }}
        />
    )
};

const AuthDocumentation = () => {
    const authContent = documentationContent[AUTH_DOC_PATH];

    return (
        <div>
            {authContent ? (
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {authContent}
                </ReactMarkdown>
            ) : (
                <p>Authentication documentation is not available right now.</p>
            )}
        </div>
    );
};

export default AuthDocumentation;
